import {areaFormat} from "@pg-mono/string-utils";

import {PropertyHouseType} from "../../../offer/detail/constants/PropertyHouseType";
import {IRoomAreaLabel} from "../../interfaces/IRoomArea";

export const actualStreetNameCheck = (streetName: string) => {
    const streetAlternativePrefixCollection = ["ul.", "al.", "pl.", "os.", "plac", "aleja", "osiedle"];
    /*
     return a flag informing weather the street is filled with real street name. In cases of village (wieś) street field is duplicated with region name.
     In order to differentiate it we show street name only when it starts with one of the words from alternative street describing collection.
     */
    return streetAlternativePrefixCollection.some((v) => streetName.includes(v));
};

export function getPropertyHouseTypeWithoutNoun(propertyHouseType: PropertyHouseType) {
    switch (propertyHouseType) {
        case PropertyHouseType.DETACHED:
            return "wolnostojący";
        case PropertyHouseType.SEMI_DETACHED:
            return "bliźniak";
        case PropertyHouseType.SERIAL:
            return "szeregowy";
        case PropertyHouseType.WOODEN:
            return "z bali";
        default:
            throw new Error("Unknown property house type");
    }
}
export function getPropertyHouseTypeVerbose(propertyHouseType: PropertyHouseType) {
    switch (propertyHouseType) {
        case PropertyHouseType.DETACHED:
            return "wolnostojącym";
        case PropertyHouseType.SEMI_DETACHED:
            return "bliźniaku";
        case PropertyHouseType.SERIAL:
            return "szeregowym";
        case PropertyHouseType.WOODEN:
            return "z bali";
        default:
            throw new Error("Unknown property house type");
    }
}

export enum RoomListType {
    LIVING_ROOM = "Pokój dzienny",
    BEDROOM = "Sypialnia",
    DINING_ROOM = "Jadalnia",
    ROOM = "Pokój",
    OFFICE = "Gabinet",
    KITCHEN = "Kuchnia",
    BATHROOM = "Łazienka",
    WC = "WC",
    CORRIDOR = "Korytarz",
    STAIRS = "Schody",
    WARDROBE = "Garderoba",
    UTILITY_ROOM = "Pomieszczenie gospodarcze",
    ENTRESOL = "Antresola",
    ATTIC = "Poddasze"
}

interface RoomType {
    type: string;
    rooms: IRoomAreaLabel[];
    areas: number[];
    areasString: string;
}

export const getRoomListTypeMap = (roomListTypes: IRoomAreaLabel[]) => {
    return roomListTypes.reduce<Record<RoomListType | string, RoomType>>(
        (acc, room) => {
            const {type, area} = room;
            const areaFormatted = areaFormat(area);

            if (acc[type]) {
                acc[type] = {
                    type: room.type,
                    rooms: acc[type].rooms.concat(room),
                    areas: acc[type].areas.concat(area),
                    areasString: acc[type].areasString.concat(areaFormatted ? `, ${areaFormatted}` : "")
                };

                return acc;
            }

            acc[type] = {
                type: room.type,
                rooms: [room],
                areas: [area],
                areasString: areaFormatted ?? ""
            };

            return acc;
        },
        {} as Record<RoomListType, RoomType>
    );
};
import {areaFormat} from "@pg-mono/string-utils";

import {PropertyHouseType} from "../../../offer/detail/constants/PropertyHouseType";
import {IRoomAreaLabel} from "../../interfaces/IRoomArea";

export const actualStreetNameCheck = (streetName: string) => {
    const streetAlternativePrefixCollection = ["ul.", "al.", "pl.", "os.", "plac", "aleja", "osiedle"];
    /*
     return a flag informing weather the street is filled with real street name. In cases of village (wieś) street field is duplicated with region name.
     In order to differentiate it we show street name only when it starts with one of the words from alternative street describing collection.
     */
    return streetAlternativePrefixCollection.some((v) => streetName.includes(v));
};

export function getPropertyHouseTypeWithoutNoun(propertyHouseType: PropertyHouseType) {
    switch (propertyHouseType) {
        case PropertyHouseType.DETACHED:
            return "wolnostojący";
        case PropertyHouseType.SEMI_DETACHED:
            return "bliźniak";
        case PropertyHouseType.SERIAL:
            return "szeregowy";
        case PropertyHouseType.WOODEN:
            return "z bali";
        default:
            throw new Error("Unknown property house type");
    }
}
export function getPropertyHouseTypeVerbose(propertyHouseType: PropertyHouseType) {
    switch (propertyHouseType) {
        case PropertyHouseType.DETACHED:
            return "wolnostojącym";
        case PropertyHouseType.SEMI_DETACHED:
            return "bliźniaku";
        case PropertyHouseType.SERIAL:
            return "szeregowym";
        case PropertyHouseType.WOODEN:
            return "z bali";
        default:
            throw new Error("Unknown property house type");
    }
}

export enum RoomListType {
    LIVING_ROOM = "Pokój dzienny",
    BEDROOM = "Sypialnia",
    DINING_ROOM = "Jadalnia",
    ROOM = "Pokój",
    OFFICE = "Gabinet",
    KITCHEN = "Kuchnia",
    BATHROOM = "Łazienka",
    WC = "WC",
    CORRIDOR = "Korytarz",
    STAIRS = "Schody",
    WARDROBE = "Garderoba",
    UTILITY_ROOM = "Pomieszczenie gospodarcze",
    ENTRESOL = "Antresola",
    ATTIC = "Poddasze"
}

interface RoomType {
    type: string;
    rooms: IRoomAreaLabel[];
    areas: number[];
    areasString: string;
}

export const getRoomListTypeMap = (roomListTypes: IRoomAreaLabel[]) => {
    return roomListTypes.reduce<Record<RoomListType | string, RoomType>>(
        (acc, room) => {
            const {type, area} = room;
            const areaFormatted = areaFormat(area);

            if (acc[type]) {
                acc[type] = {
                    type: room.type,
                    rooms: acc[type].rooms.concat(room),
                    areas: acc[type].areas.concat(area),
                    areasString: acc[type].areasString.concat(areaFormatted ? `, ${areaFormatted}` : "")
                };

                return acc;
            }

            acc[type] = {
                type: room.type,
                rooms: [room],
                areas: [area],
                areasString: areaFormatted ?? ""
            };

            return acc;
        },
        {} as Record<RoomListType, RoomType>
    );
};
